<template>
  <nuttrema-layout-content theme="global" class="is-have-margin is-central-scroll">
    <template slot="central">
      <nuttrema-hi-john></nuttrema-hi-john>


        <el-row :gutter="28" style="flex-grow: 1">
          <el-col :span="16" :offset="_get(DashboardSettings, 'data.tweets') ? 0 : 4" style="position:relative">
            <widget-notices-subscription-expiry v-if="!NoticesInstance.fetching" :NoticesInstance="NoticesInstance"></widget-notices-subscription-expiry>

            <widget-notices-instance v-if="!NoticesInstance.fetching" :NoticesInstance="NoticesInstance"></widget-notices-instance>

            <widget-notices-personal></widget-notices-personal>

            <widget-videos-carousel v-if="_get(DashboardSettings, 'data.videoTutorials')"></widget-videos-carousel>
          </el-col>

          <el-col :span="8" v-if="_get(DashboardSettings, 'data.tweets')">
            <widget-twitter-latest></widget-twitter-latest>
          </el-col>
        </el-row>


      <nuttrema-footer></nuttrema-footer>

    </template>
  </nuttrema-layout-content>
</template>


<script>
import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import NuttremaHiJohn from 'components/ui/label/nuttrema-hi-john';

import NuttremaFooter from 'components/ui/panels/nuttrema-footer';

import WidgetNoticesInstance from 'components/ui/widgets/widget-notices-instance';
import WidgetNoticesPersonal from 'components/ui/widgets/widget-notices-personal';
import WidgetTwitterLatest from 'components/ui/widgets/widget-twitter-latest';
import WidgetVideosCarousel from 'components/ui/widgets/widget-videos-carousel';
import WidgetNoticesSubscriptionExpiry from 'components/ui/widgets/widget-notices-subscription-expiry';

export default {
  name: 'page-dashboard',
  mixins: [
    PageProps,
  ],
  components: {
    NuttremaHiJohn,
    NuttremaFooter,
    WidgetTwitterLatest,
    NuttremaLayoutContent,
    WidgetNoticesInstance,
    WidgetNoticesPersonal,
    WidgetVideosCarousel,
    WidgetNoticesSubscriptionExpiry,
  },
  computed: {
    NoticesInstance() {
      return this.$store.getters.NoticesInstance;
    },
    DashboardSettings() {
      return this.$store.getters.DashboardSettings;
    },
  },
  created() {
    this.$store.dispatch('GetDashboardSettings');
  },
  beforeDestroy() {
    this.$store.dispatch('ClearDashboardSettings');
  },
};
</script>

<style lang="scss" scoped>
  .dashboard_content {
    display: flex;
    flex-grow: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/home/page-dashboard.vue